// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OYT0","textarea":"styles_textarea__LQEzS"};